class Device {

    isIos() {
        let userAgent = window.navigator.userAgent;
        return (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) ;
    }

    isMobile() {

        if (window.androidNative) {
            return true;
        } else if (window.webkit) {
            return true;
        } else{
            return false;
        }
    }

    ansPlatform() {
        return this.isIos() ? "APNS" : "GCM";
    }

    /**
     * Registra a plataforma de login
     */
    requestDeviceToken() {
        if (!this.isIos()) {
            if (window.androidNative) {
                window.androidNative.getDeviceToken();
            }
        } else if (window.webkit) {
            window.webkit.messageHandlers.observe.postMessage({ action : 'getDeviceToken', params : {}});
        }
    }

    /**
     * Request native code to open reader with the file
     * @param url  - url from the file
     * @param name -
     * @param id   -
     */
    requestOpenReader(filename) {
        if (!this.isIos()) {
            if (window.androidNative) {
                window.androidNative.getOpenReader(filename);
            }
        } else if (window.webkit) {
            window.webkit.messageHandlers.observe.postMessage({ action : 'getOpenReader', params: { filename: filename } });
        }
    }

    requestOpenLibraryFile(filename) {
        if (!this.isIos()) {
            if (window.androidNative) {
                window.androidNative.getOpenLibraryFile(filename);
            }
        } else if (window.webkit) {
            window.webkit.messageHandlers.observe.postMessage({ action : 'getOpenLibraryFile', params: { filename: filename } });
        }
    }

    /**
     * Call the native method to download the file
     * @param url  - url from the file
     * @param name -
     * @param id   -
     */
    requestDownloadFile(url, name, id, isLibrary) {
        if (!this.isIos()) {
            if (window.androidNative) {
                window.androidNative.getDownloadFile(url, name, id, isLibrary);
            }
        } else if (window.webkit) {
            window.webkit.messageHandlers.observe.postMessage({ action : 'getDownloadFile', params : {url: url, name: name, id: id, isLibrary: isLibrary} });
        }
    }

    /**
     * Call the native method to delete the file
     * @param url  - url from the file
     * @param name -
     * @param id   -
     */
    requestDeleteFile(url, name, id) {
        if (!this.isIos()) {
            if (window.androidNative) {
                window.androidNative.getRemoveFile(url, name, id);
            }
        } else if (window.webkit) {
            window.webkit.messageHandlers.observe.postMessage({ action : 'getRemoveFile', params : {url: url, name: name, id: id} });
        }
    }

    requestOpenEmailProvider(){
        if (!this.isIos()) {
            if (window.androidNative) {
                window.androidNative.getOpenEmailProvider();
            }
        } else if (window.webkit) {
            window.webkit.messageHandlers.observe.postMessage({ action : 'getOpenEmailProvider', params : {} });
        }
    }

    requestQrCodeScan(){
        if (!this.isIos()) {
            if (window.androidNative) {
                window.androidNative.getQrCodeReader();
            }
        } else if (window.webkit) {
            window.webkit.messageHandlers.observe.postMessage({ action : 'getQrCodeReader', params : {} });
        }
    }

}

export default new Device();


// WEBPACK FOOTER //
// ./src/utils/Device.js